export const layoutsPaths = {
  GET_LAYOUT_GROUPS: "/layoutGroups",
};

export const getIFolioPath = (folioId) => `/edit/${folioId}`;
export const getStatisticsPath = (folioId) => `/ifolio/statistics/${folioId}`;
export const getSharedStatisticsPath = (folioId, track) =>
  `/ifolio/statistics/${folioId}/shared_detail/${track}`;
